import type { TextPiece } from "@workspace/crystallize/generated/discovery/";

export default function Text({ text }: TextPiece) {
	const body = text?.[0]?.body;
	return (
		<div
			className="prose prose-lg container mx-auto"
			// biome-ignore lint/security/noDangerouslySetInnerHtml: <We are receiving html from Crystallize>
			dangerouslySetInnerHTML={{ __html: body ?? "" }}
		/>
	);
}
